export default "__VITE_ASSET__Bbof$k4V__"